/**
 * Nigel Sylvester — Theme JS
 * Game embed, cart drawer, signup modal, video modal.
 */

(function () {
  "use strict";

  window.NS = window.NS || {};

  var GAME_URL = "https://react-tetris-cyan.vercel.app/?embed=1";
  var SIGNUP_STORAGE_KEY = "ns-signup-dismissed";
  var VIDEO_ANIM_MS = 500;
  var SIGNUP_AUTO_MS = 3000;

  // --- Game modal ---
  var gModal, gBackdrop, gIframe, gLoader, gContainer;
  var isGameOpen = false;

  function getGameEls() {
    if (gModal) return;
    gModal = document.getElementById("game-modal");
    gBackdrop = document.getElementById("game-modal-backdrop");
    gIframe = document.getElementById("game-iframe");
    gLoader = document.getElementById("game-modal-loader");
    gContainer = document.getElementById("game-modal-container");
  }

  function showGameLoader(show) {
    getGameEls();
    if (gLoader) gLoader.style.display = show ? "flex" : "none";
  }

  NS.openGame = function () {
    getGameEls();
    if (!gModal || !gIframe || isGameOpen) return;
    isGameOpen = true;
    showGameLoader(true);
    gIframe.src = GAME_URL;
    gModal.classList.add("is-open");
    gModal.setAttribute("aria-hidden", "false");
    document.body.classList.add("is-game-mode");
  };

  NS.closeGame = function () {
    getGameEls();
    if (!gModal || !isGameOpen) return;
    isGameOpen = false;
    gModal.classList.remove("is-open");
    gModal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("is-game-mode");
    if (gIframe) gIframe.src = "";
    showGameLoader(true);
    if (NS.resumeCarouselVideos) NS.resumeCarouselVideos();
  };

  window.closeGameModal = function () {
    NS.closeGame();
  };

  window.addEventListener("message", function (e) {
    if (!e || !e.data) return;
    var d = e.data;
    if (typeof d === "string") {
      try {
        d = JSON.parse(d);
      } catch (err) {
        if (d === "tetris-close" || d.indexOf("tetris") !== -1) NS.closeGame();
        return;
      }
    }
    if (d && (d.type === "tetris-ready" || d.tetris === "ready")) {
      showGameLoader(false);
    }
    if (d && (d.type === "tetris-close" || d.action === "close")) {
      NS.closeGame();
    }
  });

  // --- Cart drawer ---
  var cDrawer, cBackdrop, cBody, cFooter, cSubtotal;
  var isCartOpen = false;

  function getCartEls() {
    if (cDrawer) return;
    cDrawer = document.getElementById("cart-drawer");
    cBackdrop = document.getElementById("cart-drawer-backdrop");
    cBody = document.getElementById("cart-drawer-body");
    cFooter = document.getElementById("cart-drawer-footer");
    cSubtotal = document.getElementById("cart-drawer-subtotal");
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    getCartEls();
    if (!cBody) return;

    if (!cart || !cart.items || cart.items.length === 0) {
      cBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
      if (cFooter) cFooter.style.display = "none";
      cBody.onclick = null;
      return;
    }

    var html = "";
    cart.items.forEach(function (item, idx) {
      var line = item.line != null ? item.line : idx + 1;
      var img = item.image || "";
      var title = item.product_title || item.title || "";
      var variant =
        item.variant_title && item.variant_title !== "Default Title"
          ? item.variant_title
          : "";
      html += '<div class="cart-drawer__item">';
      if (img) {
        html +=
          '<img class="cart-drawer__item-image" src="' +
          img +
          '" alt="" width="80" height="80" loading="lazy">';
      }
      html += '<div class="cart-drawer__item-details">';
      html +=
        '<a class="cart-drawer__item-title" href="' +
        (item.url || "#") +
        '">' +
        title +
        "</a>";
      if (variant) {
        html += '<p class="cart-drawer__item-variant">' + variant + "</p>";
      }
      html +=
        '<p class="cart-drawer__item-price">' +
        formatMoney(item.final_line_price) +
        "</p>";
      html += '<div class="cart-drawer__item-qty">';
      html +=
        '<button type="button" aria-label="Decrease quantity" data-cart-line="' +
        line +
        '" data-cart-delta="-1">\u2212</button>';
      html += "<span>" + item.quantity + "</span>";
      html +=
        '<button type="button" aria-label="Increase quantity" data-cart-line="' +
        line +
        '" data-cart-delta="1">+</button>';
      html += "</div>";
      html +=
        '<button type="button" class="cart-drawer__item-remove" data-cart-line="' +
        line +
        '">Remove</button>';
      html += "</div></div>";
    });

    cBody.innerHTML = html;
    if (cFooter) cFooter.style.display = "block";
    if (cSubtotal) cSubtotal.textContent = formatMoney(cart.total_price);

    cBody.onclick = function (ev) {
      var rm = ev.target.closest(".cart-drawer__item-remove");
      if (rm) {
        var lineRm = parseInt(rm.getAttribute("data-cart-line"), 10);
        if (!isNaN(lineRm)) NS.Cart.changeQty(lineRm, 0);
        return;
      }
      var b = ev.target.closest("[data-cart-delta]");
      if (!b) return;
      var line = parseInt(b.getAttribute("data-cart-line"), 10);
      var delta = parseInt(b.getAttribute("data-cart-delta"), 10);
      var wrap = b.parentElement;
      var span = wrap ? wrap.querySelector("span") : null;
      var qty = span ? parseInt(span.textContent, 10) || 0 : 0;
      if (!isNaN(line) && !isNaN(delta)) {
        NS.Cart.changeQty(line, qty + delta);
      }
    };
  }

  NS.Cart = {
    open: function () {
      getCartEls();
      if (!cDrawer) return;
      NS.Cart.refresh();
      isCartOpen = true;
      cDrawer.classList.add("is-open");
      cDrawer.setAttribute("aria-hidden", "false");
    },
    close: function () {
      getCartEls();
      if (!cDrawer) return;
      isCartOpen = false;
      cDrawer.classList.remove("is-open");
      cDrawer.setAttribute("aria-hidden", "true");
    },
    refresh: function () {
      fetch("/cart.js")
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          renderCart(cart);
          NS.Cart.updateCount(cart.item_count);
        })
        .catch(function () {
          if (cBody) {
            cBody.innerHTML =
              '<p class="cart-drawer__empty">Could not load cart.</p>';
          }
        });
    },
    changeQty: function (line, quantity) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          renderCart(cart);
          NS.Cart.updateCount(cart.item_count);
        })
        .catch(function () {
          NS.Cart.refresh();
        });
    },
    updateCount: function (n) {
      var el = document.querySelector(".site-nav__cart-count");
      if (el) el.textContent = "(" + (n != null ? n : 0) + ")";
    },
  };

  // --- Signup modal ---
  var sModal, sBackdrop;
  var isSignupOpen = false;

  function getSignupEls() {
    if (sModal) return;
    sModal = document.getElementById("signup-modal");
    sBackdrop = document.getElementById("signup-modal-backdrop");
  }

  NS.Signup = {
    open: function () {
      getSignupEls();
      if (!sModal) return;
      isSignupOpen = true;
      sModal.classList.add("is-open");
      sModal.setAttribute("aria-hidden", "false");
    },
    close: function () {
      getSignupEls();
      if (!sModal) return;
      isSignupOpen = false;
      sModal.classList.remove("is-open");
      sModal.setAttribute("aria-hidden", "true");
      try {
        localStorage.setItem(SIGNUP_STORAGE_KEY, "1");
      } catch (e) {}
    },
  };

  NS.openModal = function (url) {
    if (url) NS.openVideo(url);
  };
  NS.closeModal = function () {
    NS.closeVideo();
  };

  // --- Video modal ---
  var vModal, vBackdrop, vCloseBtn, vContainer, vIframe;
  var isVideoOpen = false;
  var videoCloseTimer = null;

  function getVideoEls() {
    if (vModal) return;
    vModal = document.getElementById("video-modal");
    vBackdrop = document.getElementById("video-modal-backdrop");
    vCloseBtn = document.getElementById("video-modal-close");
    vContainer = document.getElementById("video-modal-container");
    vIframe = document.getElementById("video-iframe");
  }

  NS.openVideo = function (url) {
    getVideoEls();
    if (!vModal || !vIframe || isVideoOpen) return;

    if (videoCloseTimer) {
      clearTimeout(videoCloseTimer);
      videoCloseTimer = null;
    }

    vIframe.src = url;
    document.body.classList.add("is-video-mode");
    vModal.classList.add("is-open");
    vModal.setAttribute("aria-hidden", "false");
    isVideoOpen = true;

    if (vCloseBtn) vCloseBtn.focus();
  };

  NS.closeVideo = function () {
    getVideoEls();
    if (!vModal || !isVideoOpen) return;
    isVideoOpen = false;

    vModal.classList.remove("is-open");
    vModal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("is-video-mode");

    videoCloseTimer = setTimeout(function () {
      if (vIframe) vIframe.src = "";
      videoCloseTimer = null;
      if (NS.resumeCarouselVideos) NS.resumeCarouselVideos();
    }, VIDEO_ANIM_MS);
  };

  // --- DOMContentLoaded: backdrops, signup form, auto-open ---
  document.addEventListener("DOMContentLoaded", function () {
    getGameEls();
    if (gBackdrop) {
      gBackdrop.addEventListener("click", function () {
        NS.closeGame();
      });
    }

    getCartEls();
    if (cBackdrop) {
      cBackdrop.addEventListener("click", function () {
        NS.Cart.close();
      });
    }

    getSignupEls();
    if (sBackdrop) {
      sBackdrop.addEventListener("click", function () {
        NS.Signup.close();
      });
    }

    getVideoEls();
    if (vBackdrop) {
      vBackdrop.addEventListener("click", function () {
        NS.closeVideo();
      });
    }

    var signupForm = document.getElementById("signup-modal-form");
    var signupSuccess = document.getElementById("signup-success");
    var signupBtn = document.getElementById("signup-submit-btn");

    /**
     * Shopify newsletter POST often returns 3xx to ?customer_posted=true.
     * redirect: manual — 3xx has empty body; redirect: follow — follow-up GET
     * can be non-2xx even when the customer was created. Treat 3xx as success
     * unless Location points at a bot challenge.
     */
    function newsletterResponseLooksOk(r, text) {
      var t = text || "";
      var u = (r && r.url) || "";
      if (r && r.ok) return true;
      if (u.indexOf("customer_posted=true") !== -1) return true;
      if (t.indexOf("customer_posted") !== -1) return true;
      if (r && t && /form-message--error|form__message--error|class="(field|form)-error/i.test(t))
        return false;
      return false;
    }

    function finishNewsletterFetch(r) {
      var s = r.status;
      if (s >= 301 && s < 400) {
        var loc = "";
        try {
          loc = r.headers.get("Location") || "";
        } catch (e) {}
        if (loc.indexOf("challenge") !== -1) {
          return r.text().then(function (text) {
            if (newsletterResponseLooksOk(r, text)) return;
            throw new Error("signup failed");
          });
        }
        return Promise.resolve();
      }
      return r.text().then(function (text) {
        if (newsletterResponseLooksOk(r, text)) return;
        throw new Error("signup failed");
      });
    }

    if (signupForm) {
      signupForm.addEventListener("submit", function (e) {
        e.preventDefault();
        if (signupBtn) {
          signupBtn.disabled = true;
          signupBtn.textContent = "Sending...";
        }

        var fd = new FormData(signupForm);
        var action = signupForm.action || "/contact";

        fetch(action, {
          method: "POST",
          body: fd,
          credentials: "same-origin",
          redirect: "manual",
          headers: { "X-Requested-With": "XMLHttpRequest" },
        })
          .then(finishNewsletterFetch)
          .then(function () {
            if (signupSuccess) {
              signupSuccess.textContent = "You're in. Thanks for subscribing.";
            }
            if (signupBtn) {
              signupBtn.disabled = true;
              signupBtn.textContent = "Signed up";
            }
            try {
              localStorage.setItem(SIGNUP_STORAGE_KEY, "1");
            } catch (err) {}
            setTimeout(function () {
              NS.Signup.close();
            }, 1200);
          })
          .catch(function () {
            if (signupSuccess) {
              signupSuccess.textContent = "";
            }
            if (signupBtn) {
              signupBtn.disabled = false;
              signupBtn.textContent = "Sign Up";
            }
          });
      });
    }

    var footerThanks = document.getElementById("footer-newsletter-thanks");
    if (footerThanks) {
      setTimeout(function () {
        footerThanks.setAttribute("hidden", "hidden");
        footerThanks.style.display = "none";
      }, 5000);
    }

    try {
      if (!localStorage.getItem(SIGNUP_STORAGE_KEY)) {
        setTimeout(function () {
          if (!localStorage.getItem(SIGNUP_STORAGE_KEY)) NS.Signup.open();
        }, SIGNUP_AUTO_MS);
      }
    } catch (e) {}

    fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        NS.Cart.updateCount(c.item_count);
      })
      .catch(function () {});
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    e.stopPropagation();
    if (isGameOpen) NS.closeGame();
    else if (isCartOpen) NS.Cart.close();
    else if (isSignupOpen) NS.Signup.close();
    else if (isVideoOpen) NS.closeVideo();
  });
})();
